import { useParams } from 'react-router-dom';

import { useSessions } from '@/hooks/useSwr';

import { ProjectPageV2 } from '../Project/Project';

const PublicProject = () => {
  const { sessionId, datasetShareToken } = useParams();
  const session = useSessions(
    {
      id: sessionId ? [sessionId] : undefined,
      include_stats: false,
    },
    { datasetShareToken }
  );
  const firstSession = session?.data?.rows?.[0];

  return firstSession?.id ? (
    <ProjectPageV2
      sessionId={firstSession.id}
      session={firstSession}
      isPublic={true}
    />
  ) : null;
};

export default PublicProject;
